import(/* webpackMode: "eager", webpackExports: ["NexusEmbedLoader"] */ "/app/components/marketing/nexus-embed-loader.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
